export function QuickPromptChipsSkeleton() {
  return (
    <div className="flex animate-pulse gap-3 overflow-hidden">
      <div className="h-10 w-28 rounded-full bg-muted" />
      <div className="h-10 w-24 rounded-full bg-muted" />
      <div className="h-10 w-32 rounded-full bg-muted" />
    </div>
  );
}
